import Home from "./pages/home";
import {BrowserRouter, Route, Routes} from 'react-router-dom';
import About from "./pages/about";
import Contactus from "./pages/contactus";
import {initializeApp} from "firebase/app";
import Products from "./pages/products";
import Services from "./pages/services";

function App() {
    //console.log(window.location.href);

    const firebaseConfig = {
        apiKey: "AIzaSyBdi7WyXfXHtfks3kk5snYLXDoLVblNrA0",
        authDomain: "cosmoneural.firebaseapp.com",
        projectId: "cosmoneural",
        storageBucket: "cosmoneural.appspot.com",
        messagingSenderId: "823390198418",
        appId: "1:823390198418:web:e672730cd123166975244b",
        measurementId: "G-J2LD8KBML3"
    };

    initializeApp(firebaseConfig);

    return (
        <BrowserRouter>
            <Routes>
                <Route path="/" element={<Home/>}/>
                <Route path="/about" element={<About/>}/>
                <Route exact path="/contactus" element={<Contactus/>}/>
                <Route exact path="/products" element={<Products/>}/>
                <Route exact path="/services" element={<Services/>}/>
            </Routes>
        </BrowserRouter>
    );
}

export default App;
